<template>
	<a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="70%">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="id" name="id">
					<a-input v-model:value="form.id" />
				</a-form-item>
			</div>
            <a-row :gutter="30">
                <a-col :span=12>
                    <a-form-item label="项目评审名称" name="projectReviewName">
                        <a-input v-model:value="form.projectReviewName" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span=12>
                    <a-form-item label="计划评审时间" name="reviewPlanTime">
                        <date-picker :disabled-date="disabledDate"  value-format="yyyy-MM-DD" v-model:value="form.reviewPlanTime" placeholder="请选择" />
                    </a-form-item>
                </a-col>
            </a-row>

			<a-form-item label="项目评审概述" name="projectOverview">
				<a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" v-model:value="form.projectOverview" placeholder="请输入" />
			</a-form-item>
            <a-row :gutter="30" :style="{marginBottom:'5vh'}">
                <a-col :span="12">
                    <a-form-item label="会议纪要(PDF)" name="meetingMinutes">
                        <FileUpload v-model:value="form.meetingMinutes" :multiple="true" :size="50" :count="3" :is-pdf="true"></FileUpload>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目评审内容(PDF)" name="applicationAttachment">
                        <FileUpload v-model:value="form.applicationAttachment" :multiple="true" :size="50" :count="3" :is-pdf="true"></FileUpload>
                    </a-form-item>
                </a-col>
            </a-row>
			<!--可编辑区域 end-->
		</a-form>

	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { application } from "@/api/projectReviewService";
import DatePicker from "@/components/form/datePicker/DatePicker";
import FileUpload from "@/components/form/upload/FileUpload";
import moment from "moment";
export default {
	name: "AddOrEditModal",
	components: {FileUpload, DatePicker },
	mixins: [formMixin],
	data() {
		return {
			options: [],
			form: {

			},
			rules: {
				id: [],
                projectReviewName: [dataCheck.required({})],
                projectOverview: [dataCheck.required({})],
                reviewPlanTime: [dataCheck.required({})],
                meetingMinutes: [dataCheck.required({})],
                applicationAttachment: [dataCheck.required({})],
                preReviewId:[]
			},
			submitUrl: application.save
		}
	},
	created() {
	},
	methods: {
        onSuccessFn(){
            this.$router.push("/sys/application/info")
        },
        disabledDate(current){
            // return current < moment().subtract(1,'days').endOf('day');
            return current < moment().startOf("day")
        }
	},
}
</script>
<style scoped lang="less">

</style>
